import React from 'react';

import {getHost} from '@albert-io/environment';

import SocialButton from '../SocialButton';

import icon from './assets/clever.svg';

function getCleverSocialSignInLink() {
  return `${getHost()}/auth/clever`;
}

interface Props {
  disabled?: boolean;
  stayOnCurrentPageAfterAuth?: boolean;
}

export default function CleverButton({disabled = false, stayOnCurrentPageAfterAuth}: Props) {
  return (
    <SocialButton
      disabled={disabled}
      provider='clever'
      href={getCleverSocialSignInLink()}
      stayOnCurrentPageAfterAuth={stayOnCurrentPageAfterAuth}
    >
      <img className='sso-button__logo' src={icon} alt='' />
      &nbsp;Log in with Clever
    </SocialButton>
  );
}
